import OpenCard from './OpenCard';

export default OpenCard;
